import { environment } from 'src/environments/environment';

export const PRICING_CALCULATOR_APIS_ENDPOINTS = {
  CALCULATE_CPA: (productId: string): string =>
    `${environment.BACKEND_URL}api/products/${productId}/pricing-calculator`,
};
